import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Instagram, Facebook, MessageCircle, Music2, Ghost } from "lucide-react";
import Logo from "@/components/Logo";

export default function Footer() {
  const { t } = useApp();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10 mt-24">
      <div className="container-narrow py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2 md:col-span-2">
          <Logo size="xl" to={null} />
          <div className="text-[10px] tracking-[0.3em] uppercase text-white/50 mt-3">{t("brand_tagline")}</div>
          <p className="text-white/60 text-sm mt-6 max-w-sm leading-relaxed">
            {t("contact_short")}<br/>+41 78 202 12 72
          </p>
          <div className="flex items-center gap-4 mt-6">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram" className="text-white/60 hover:text-gold transition-colors"><Instagram size={20} strokeWidth={1.5} /></a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook" className="text-white/60 hover:text-gold transition-colors"><Facebook size={20} strokeWidth={1.5} /></a>
            <a href="https://tiktok.com" target="_blank" rel="noreferrer" aria-label="TikTok" className="text-white/60 hover:text-gold transition-colors"><Music2 size={20} strokeWidth={1.5} /></a>
            <a href="https://snapchat.com" target="_blank" rel="noreferrer" aria-label="Snapchat" className="text-white/60 hover:text-gold transition-colors"><Ghost size={20} strokeWidth={1.5} /></a>
            <a href="https://wa.me/41782021272" target="_blank" rel="noreferrer" aria-label="WhatsApp" className="text-white/60 hover:text-gold transition-colors"><MessageCircle size={20} strokeWidth={1.5} /></a>
          </div>
        </div>
        <div>
          <div className="eyebrow mb-4">{t("footer_shop")}</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/shop/natuerliche-oele" className="hover:text-gold">{t("cat_natuerliche_oele")}</Link></li>
            <li><Link to="/shop/aleppo-seife" className="hover:text-gold">{t("cat_aleppo_seife")}</Link></li>
            <li><Link to="/shop/henna" className="hover:text-gold">{t("cat_henna")}</Link></li>
            <li><Link to="/shop/miswak" className="hover:text-gold">{t("cat_miswak")}</Link></li>
            <li><Link to="/shop/weihrauch" className="hover:text-gold">{t("cat_weihrauch")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-4">{t("footer_help")}</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/order-tracking" className="hover:text-gold">{t("nav_tracking")}</Link></li>
            <li><Link to="/consultation" className="hover:text-gold">{t("nav_consultation")}</Link></li>
            <li><Link to="/shipping" className="hover:text-gold">{t("footer_shipping")}</Link></li>
            <li><Link to="/returns" className="hover:text-gold">{t("footer_returns")}</Link></li>
            <li><Link to="/faq" className="hover:text-gold">{t("footer_faq")}</Link></li>
            <li><Link to="/contact" className="hover:text-gold">{t("nav_contact")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-4">{t("footer_legal")}</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/impressum" className="hover:text-gold">{t("footer_impressum")}</Link></li>
            <li><Link to="/datenschutz" className="hover:text-gold">{t("footer_datenschutz")}</Link></li>
            <li><Link to="/agb" className="hover:text-gold">{t("footer_agb")}</Link></li>
            <li><Link to="/payments" className="hover:text-gold">{t("payments_title")}</Link></li>
            <li><Link to="/cookies" className="hover:text-gold">{t("footer_cookies")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-[11px] tracking-[0.25em] uppercase text-white/40">
        © {year} Coiffeur Tattoo 01&Co. — {t("copyright")}
      </div>
    </footer>
  );
}
